// @flow
import Handler from "./handler.js";

const TIMEOUT = 500;

export default class Manual extends Handler {
	snapTimeout: number;

	snap = () => {
		const edge = this.scroller.findNearestEdge();
		if (edge.direction !== "middle") {
			this.scroller.snapToPosition(edge.position, edge.direction);
		}
	}

	unmount() {
		clearTimeout(this.snapTimeout);
	}

	handleScroll() {
		clearTimeout(this.snapTimeout);
		this.snapTimeout = setTimeout(this.snap, TIMEOUT);
	}
}



// WEBPACK FOOTER //
// ./lib/scroller/manual.js